module.exports = __webpack_public_path__ + "img/tree-09-d-trunk.56e27b6d.png";